module.exports = __webpack_public_path__ + "img/20200514_153208.0c58a75f.jpg";